import { useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import _ from "lodash";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectDbaRegistriesListItems } from "../../../../../redux/dba-registries/selector";
import storePersist from "../../../../../redux/storePersist";
import { dbaRegistries } from "../../../../../redux/dba-registries/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { selectDbaPartnerAgencyMappingsCreatedItem } from "../../../../../redux/dba-partner-agency-mappings/selector";
import { dbaPartnerAgencyMappings } from "../../../../../redux/dba-partner-agency-mappings/action";
import * as R from "ramda"
const ShipXAgencyRegistries = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const orgRegistryItems = useSelector(selectDbaRegistriesListItems)
  const associatedPartnerCreatedItems = useSelector(selectDbaPartnerAgencyMappingsCreatedItem)
  const companyName = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.CompanyName;
  const librariesItems = storePersist?.get("library")?.current;
    const userProfileData = storePersist?.get("userProfile")?.current;
    const userProfileAccountId = userProfileData?.items[0]?.Message?.AccountDetail?.Id
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});


  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
     
            { field: 'DBNPName', headerName: 'DBNP Name'},
                { field: 'GlobalDBARegistryName', headerName: 'Global DBARegistry Name'},
            { field: 'name_of_authorised_signatory', headerName: 'Name Of Authorised Signatory', searchField: 'name_of_authorised_signatory', sortable: true, filter: true, filterType: 'text' },
            { field: 'address_of_authorisedSignatory', headerName: 'Address Of AuthorisedSignatory' },
            {
                field: 'ops_no', headerName: 'ops Number',valueFormatter: getOpsName 
            },
            { field: 'email_id', headerName: 'Email', searchField: 'email_id', sortable: true, filter: true, filterType: 'text' },
            { field: 'mobile_no', headerName: 'Mobile No' },
            { field: 'country', headerName: 'country' },
            { field: 'subscriber_id', headerName: 'Subscriber' },
            { field: 'unique_key_id', headerName: 'Unique Key' },
            { field: 'IsPartnerNetwork', headerName: 'IsPartnerNetwork',cellRenderer: 'yesNoRenderer' },
 { field: 'IsOnBoardedInShipX', headerName: 'IsOnBoardedInShipX',cellRenderer: 'yesNoRenderer' },
    ]);
  }

      const getOpsName = (storeNameId: any) => {
          const StoreNameList = R.find(
            (storeName: any) => parseInt(
              storeName.Value,
              10
            ) === parseInt(
              storeNameId,
              10
            ),
            librariesItems?.Ops_no
          )
          return StoreNameList ? StoreNameList.Description : ''
        }
  const fetchOrgRegistry = () => {

    dispatch(dbaRegistries.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/list`, entity: 'dbaRegistries', jsonData: {
        "Context": {},
        "Records": [
          {
            "IsPartnerNetwork": true,
            "IsOnBoardedInShipX": true
          }],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }
    }))

  }
  useEffect(() => {
    createColumnDefs()
    fetchOrgRegistry()
  }, [pageData])
  useEffect(() => {
    if (associatedPartnerCreatedItems?.result) {
      toast.success('Agency Onboarded successully.')
      dispatch(dbaPartnerAgencyMappings.resetAction({ actionType: 'create' }))
    }
  }, [associatedPartnerCreatedItems]);

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(dbaRegistries.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/list`, entity: 'orgRegistries', jsonData: {
        "Context": {},
        "Records": [
          {
           "IsPartnerNetwork": true,
            "IsOnBoardedInShipX": true
          }],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
        }


      }
    }))
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleReloadData = () => {
    fetchOrgRegistry();
  }
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      name: 'Reload',
      callback: () => handleReloadData(),
    },

  ];
  const handleOnBoard = (data: any) => {
    dispatch(dbaPartnerAgencyMappings.resetAction({ actionType: 'create' }))
    dispatch(dbaPartnerAgencyMappings.create({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-partner-agency-mappings`, entity: 'associatedPartner', jsonData: {
        Context:{},
        Records: [
          {
            "PartnerDBNPId": data?.PartnerDBNPId,
            "PartnerDBAId": data?.PartnerDBAId,
            "PartnerDBARegistryId": data?.Id,
            "InternalAccountId":userProfileAccountId,
            "PartnerAccountId" : data?.PartnerDBAAccountId,
            "IsApprovedByInternalAgency": true,
            "IsApprovedByPartnerAgency": false,
            "IsApprovedByInternalNP": true,
            "IsApprovedByPartnerNP":true,
             "ApprovalStatusId": 10
          }
        ]
      }
    })).then(() => {
      dispatch(dbaRegistries.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/list`, entity: 'orgRegistries', jsonData: {
          "Context": {},
          "Records": [
            {
             "IsPartnerNetwork": true,
              "IsOnBoardedInShipX": true
            }],
          "Pagination": {
            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
          }

        }
      }))
    })
  }

  const handleEdit = (data: any) => {

    navigate(`${data?.Id}`)
  }
  const handleDelete = (data: any) => {
    dispatch(dbaRegistries.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/delete`,
      entity: 'dbaRegistries',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      dispatch(dbaRegistries.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/list`, entity: 'orgRegistries', jsonData: {
          "Context": {},
          "Records": [
            {
             "IsPartnerNetwork": true,
              "IsOnBoardedInShipX": true
            }],
          "Pagination": {
            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
          }

        }
      }))
    });
  }

  return (
    <>
      {orgRegistryItems?.isLoading ? (
        <PageLoader />
      ) : (
        <>
          
          {/* Table */}
          <Table
            columnData={columnDefs}
            filterTypeLists={filterTypes}
            onSearch={handleSearch}
            rowData={orgRegistryItems?.result?.items}
            setPageData={setPageData}
            checkboxConfig={{
              allowMultiSelect: true,
              defaultSelectedIds: [],
              isDisabled: false,
              keyColumn: 'OrgRegistryId',
            }}
            additionButtons={additionButtons}
            enableFilter={true}
            IsOnboard={true}
            paginationData={orgRegistryItems?.result?.pagination}
            handleOnBoard={handleOnBoard}
            headingName={`${companyName} Agencies`}
          />
        </>
      )}
    </>
  );
};

export default ShipXAgencyRegistries;


